(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["electrotk-about-us"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root = document) => {
      root.querySelectorAll('.et-about--motion-enabled:not([data-motion-ready])').forEach((section) => {
        section.dataset.motionReady = 'true';

        if (
          window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
          !('IntersectionObserver' in window)
        ) {
          section.querySelectorAll('.et-about__reveal').forEach((item) => item.classList.add('is-visible'));
          return;
        }

        section.classList.add('et-about--motion-ready');

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              entry.target.classList.toggle('is-visible', entry.isIntersecting);
            });
          },
          { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
        );

        section.querySelectorAll('.et-about__reveal').forEach((item) => observer.observe(item));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
    } else {
      initialise();
    }

    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
